import { defineComponent as _defineComponent } from 'vue'
import { ISparring } from '@/types/sparring'
import { computed, ref } from 'vue'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { IBattle } from '@/types/battle'

interface IProps {
  sparring: ISparring
  battle: IBattle
  selectedWinner: number
  disabled?: boolean
  isSpectator?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScorelessSparring',
  props: {
    sparring: null,
    battle: null,
    selectedWinner: null,
    disabled: { type: Boolean, default: false },
    isSpectator: { type: Boolean, default: false }
  },
  emits: ["select-winner"],
  setup(__props: any, { emit }: { emit: ({ (e: 'select-winner', value: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { sparring: ISparring, battle: IBattle, selectedWinner: number, disabled: boolean, isSpectator: boolean };




const participantsArray = computed(() => [props.sparring.red, props.sparring.blue])
const selectedWinner = ref<number>(props.selectedWinner)
const isFinishedSparring = computed(() => props.sparring.status === 'finished')

return { __sfc: true,emit, props, participantsArray, selectedWinner, isFinishedSparring, BKSvgIcon }
}

})